// = Libs =
import { FC } from 'react';
import { IconProps } from '@/common/components/icons/icon.types';

// = Constants =
import COLORS from '@/constants/colors';

const CalendarIcon: FC<IconProps> = ({ color = 'dark' }) => {
  const iconColor = COLORS[color];

  return (
    <svg viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5123 3.22217V8.0555M9.48762 3.22217V8.0555M3.22217 12.8888H25.7777M5.22217 27.3888H23.7777C24.8823 27.3888 25.7777 26.4934 25.7777 25.3888V7.63883C25.7777 6.53427 24.8823 5.63883 23.7777 5.63883H5.22217C4.1176 5.63883 3.22217 6.53427 3.22217 7.63883V25.3888C3.22217 26.4934 4.1176 27.3888 5.22217 27.3888Z"
        stroke={iconColor}
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default CalendarIcon;
